module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/36770e433b22fecc706efd99c78bcd44.png";